import { bool, func } from 'prop-types';
import React from 'react';

import { getTooltipButtonWithText } from '../../../generic/Tooltip';
import { contactListShape, historyShape } from '../../../prop-types';
import withApiRequest from '../../../REST/with-api-request';
import HELP_TEXTS from '../../help-texts';
import handleCloneRequest from './handle-clone-request';

const ButtonWithTooltip = getTooltipButtonWithText(HELP_TEXTS);

function CloneContactList({ contactList, onRequest, loading, history }) {
  const onClick = () =>
    onRequest(contactList).then(cl =>
      history.push(`/contacts/contact-lists/${cl.id}/show`),
    );
  return (
    <ButtonWithTooltip
      helpKey="cloneContactList"
      section="actionButtons"
      color="primary"
      onClick={onClick}
      disabled={loading}
    >
      Clone
    </ButtonWithTooltip>
  );
}

CloneContactList.propTypes = {
  contactList: contactListShape.isRequired,
  onRequest: func.isRequired,
  loading: bool.isRequired,
  history: historyShape.isRequired,
};

export default withApiRequest({
  query: handleCloneRequest,
  error: 'flash',
  successMessage: 'Contact list cloned successfully',
})(CloneContactList);
